/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    variants: {
        notification: {
            display: 'inline-flex',
            justifyContent: 'center',
            position: 'absolute',
            top: '0.5rem',
            right: '0.5rem',
            width: '12px',
            height: '12px',
            alignItems: 'center',
            color: 'white',
            fontSize: 'xs',
            backgroundColor: 'black',
            borderRadius: 'full'
        },
        imageBadge: {
            border: '1px solid',
            borderColor: 'black.100',
            textTransform: 'uppercase',
            padding: '0 10px',
            backgroundColor: 'white',
            marginBottom: {base: '5px', lg: '15px'},
            marginRight: '10px',
            width: 'fit-content',
            borderRadius: '5px',
            fontSize: '10px',
            fontWeight: '400',
            color: 'black.100'
        },
        textBadge: {
            fontSize: '13px',
            lineHeight: '20px',
            padding: 0,
            textTransform: 'capitalize',
            letterSpacing: '0.065px',
            fontWeight: '400',
            color: 'mango.400'
        },
        textValue: {
            backgroundColor: 'white',
            fontSize: {base: '12px', lg: '16px'},
            fontWeight: '500',
            color: 'black.300',
            padding: {base: '7px 12px', lg: '10px 20px'},
            borderRadius: '0px',
            fontFamily: 'brandon-grotesque'
        },
        xxValue: {
            backgroundColor: 'white',
            padding: '10px 8px',
            color: 'black.300'
        },
        default: {
            backgroundColor: 'white',
            padding: '1px 10px',
            width: 'fit-content',
            borderRadius: '5px',
            textTransform: 'uppercase',
            fontSize: '10px',
            fontWeight: '400',
            lineHeight: '22px',
            letterSpacing: '0.8px',
            color: 'black.100'
        }
    }
}
